import getScrollTop from '../../helpers/getScrollTop';
import { getWindowWidth } from '../../helpers/getWindowDimensions';

const logoAnimationLegacy = (el) => {
  const subtitle = el.querySelector('.m-masthead-legacy__logo-letters');

  if (!subtitle) {
    return;
  }

  const letters = subtitle.querySelectorAll('path, polygon');

  let isAnimating = false;
  let isWaiting = false;

  const completeAnimation = () => {
    isAnimating = false;

    if (isWaiting) {
      isWaiting = false;
      handleWindowScroll();
    }
  };

  const hideLetters = () => {
    isAnimating = true;
    const reversed = Array.prototype.slice.call(letters).reverse();

    reversed.forEach((letter, index) => {
      setTimeout(() => {
        letter.style.display = 'none';

        if (index === (letters.length - 1)) {
          if (!document.body.classList.contains('is-nav-minimized')) {
            document.body.classList.add('is-nav-minimized');
          }

          completeAnimation();
        }
      }, index * 40);
    });
  };

  const displayLetters = () => {
    isAnimating = true;

    Array.prototype.forEach.call(letters, (letter, index) => {
      setTimeout(() => {
        document.body.classList.remove('is-nav-minimized');
        letter.style.display = 'inline';

        if (index === (letters.length - 1)) {
          completeAnimation();
        }
      }, index * 40);
    });
  };

  const handleWindowScroll = () => {
    if (getWindowWidth() <= 970) {
      return;
    }

    if (isAnimating) {
      isWaiting = true;
      return;
    }

    if (getScrollTop() > 1) {
      hideLetters();
    } else {
      displayLetters();
    }
  };

  window.addEventListener('scroll', handleWindowScroll);
};

const logo = document.querySelector('.m-masthead-legacy__logo');

if (logo) {
  logoAnimationLegacy(logo);
}
